/**
 * A type safe way to get the string name of a field within the type T.
 * @param key The field you want the name of.
 * @param instance An optional instance of T, enables you to get a field name without having to reference the type.
 */
export default function nameof<T>(key: keyof T, instance?: T): keyof T {
  return key;
}
